export default [
    {
        name:"Gauge",
        icon:"fa-tachometer-alt",
        processorFunction:(data,echarts)=>{
            let name=""
            let value=0
            for (let seriesIndex in data) {
                if(seriesIndex==="timestamp"){
                    continue;
                } else {
                    let seriesVal=data[seriesIndex].reduce((acc, curr) => curr!==null ? curr : acc)
                    if (seriesVal!==null) {
                        value=Math.round(seriesVal*100)/100
                        name=seriesIndex
                        break;
                    }
                }
            }
            return {
                series: [
                    {
                        type: 'gauge',
                        center: ['50%', '60%'],
                        startAngle: 200,
                        endAngle: -20,
                        min: 15,
                        max: 35,
                        splitNumber: 5,
                        itemStyle: {
                            color: '#FFFFFF'
                        },
                        progress: {
                            show: true,
                            overlap:false,
                            width: 15
                        },
                        pointer: {
                            show: false
                        },
                        axisLine: {
                            lineStyle: {
                                width: 30,
                                color:[[0.4, '#1f77b4'],
                                    [0.6, '#2ca02c'],
                                    [1, '#ff7f0e']]
                            }
                        },
                        axisTick: {
                            distance: -45,
                            splitNumber: 5,
                            lineStyle: {
                                width: 2,
                                color: '#FFFFFF'
                            }
                        },
                        splitLine: {
                            distance: -52,
                            length: 14,
                            lineStyle: {
                                width: 3,
                                color: '#FFFFFF'
                            }
                        },
                        axisLabel: {
                            distance: -5,
                            color: 'inherit',
                            fontSize: 12
                        },
                        anchor: {
                            show: false
                        },
                        title: {
                            show: false
                        },
                        detail: {
                            valueAnimation: true,
                            width: '60%',
                            lineHeight: 40,
                            borderRadius: 8,
                            offsetCenter: [0, '-15%'],
                            fontSize: 45,
                            fontWeight: 'bolder',
                            formatter: '{value}',
                            color: 'inherit'
                        },
                        data: [
                            {value:0, detail: {show:false}},
                            {
                                value: value,
                            },
                        ]
                    },
                    {
                        type: 'gauge',
                        center: ['50%', '60%'],
                        startAngle: 200,
                        endAngle: -20,
                        min: 40,
                        max: 50,
                        progress: {
                            show: true,
                            width: 8
                        },
                        pointer: {
                            show: false
                        },
                        axisLine: {
                            show: false
                        },
                        axisTick: {
                            show: false
                        },
                        splitLine: {
                            show: false
                        },
                        axisLabel: {
                            show: false
                        },
                        detail: {
                            show: false
                        },
                        data: [
                            {
                                value: value,
                                name:name
                            }
                        ]
                    }
                ]
            }
        }
    },
    {
        name:"Pie",
        icon:"fa-chart-pie",
        processorFunction:(data,echarts)=>{
            let chartSeries=[]
            for (let seriesIndex in data) {
                if(seriesIndex==="timestamp"){
                    continue;
                } else {
                    let value=data[seriesIndex].reduce((acc, curr) => curr!==null ? curr : acc)
                    if (value>0){
                        chartSeries.push({ value: Math.round(value*100)/100, name: seriesIndex.split(" - ")[0] })
                    }
                }

            }
            return {
                color: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                label: {
                    alignTo: 'edge',
                    formatter:'{name|{b}}\n{number|{c}} ({percentage|{d} %})',
                    minMargin: 5,
                    edgeDistance: 10,
                    lineHeight: 18,
                    fontSize:14,
                    color:"#FFFFFF",
                    rich: {
                        name:{
                            fontWeight:550,
                            fontSize:15
                        },
                        percentage:{
                            fontWeight:550,
                            fontSize:14
                        }
                    }
                },
                labelLine: {
                    length: 15,
                    length2: 0,
                    maxSurfaceAngle: 80
                },
                title: {
                    text: '',
                    left: 'center',
                    textStyle: {
                        fontSize:16,
                        fontWeight:500,
                        color:"#FFFFFF"
                    }

                },
                tooltip: {
                    trigger: 'item'
                },
                legend: {
                    orient: 'horizontal',
                    top:'bottom'
                },
                series: [
                    {
                        type: 'pie',
                        radius: ['47%', '60%'],
                        avoidLabelOverlap: true,
                        itemStyle: {
                            borderRadius: 10,
                        },
                        data: chartSeries,
                    }
                ],
            }
        }
    },{
        name:"Stacked Bar",
        icon:"fa-chart-bar",
        processorFunction:(data, echarts)=>{
            var chartSeries = [];
            for (var seriesIndex in data) {
                if (seriesIndex === "timestamp") {
                    continue;
                } else {
                    chartSeries.push({
                        data:data[seriesIndex],
                        name: seriesIndex,
                        type: 'bar',
                        stack: 'total',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                    });

                }
            }

            return {
                color: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    top: 'bottom'
                },

                yAxis: {
                    type: 'value'
                },
                xAxis: {
                    data: data.timestamp,
                },
                series:chartSeries
            };
        }
    },{
        name:"Grouped Bar",
        icon:"fa-chart-bar",
        processorFunction:(data, echarts)=>{
            var chartSeries = [];
            for (var seriesIndex in data) {
                if (seriesIndex === "timestamp") {
                    continue;
                } else {
                    chartSeries.push({
                        data:data[seriesIndex],
                        name: seriesIndex,
                        type: 'bar',
                        label: {
                            show: true
                        },
                        emphasis: {
                            focus: 'series'
                        },
                    });

                }
            }

            return {
                color: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'shadow'
                    }
                },
                legend: {
                    top: 'bottom'
                },

                yAxis: {
                    type: 'value'
                },
                xAxis: {
                    data: data.timestamp,
                },
                series:chartSeries
            };
        }
    },{
        name:"Stacked Area",
        icon:"fa-chart-area",
        processorFunction:(data, echarts)=>{
            var chartSeries = [];

            for (var seriesIndex in data) {
                if (seriesIndex === "timestamp") {
                    continue;
                } else {
                    chartSeries.push({
                        data:data[seriesIndex],
                        name: seriesIndex,
                        type: 'line',
                        stack: 'Total',
                        areaStyle: {},
                        emphasis: {
                            focus: 'series'
                        },});

                }
            }
            return {
                color: ['#1f77b4', '#ff7f0e', '#2ca02c', '#d62728', '#9467bd', '#8c564b', '#e377c2', '#7f7f7f', '#bcbd22', '#17becf'],
                tooltip: {
                    trigger: 'axis',
                    axisPointer: {
                        type: 'cross',
                        label: {
                            backgroundColor: '#6a7985'
                        }
                    }
                },
                legend: {top: 'bottom'},
                yAxis: {
                    type: 'value'
                },
                xAxis: {
                    data: data.timestamp
                },
                series:chartSeries
            };
        }
    },
]